import { constants } from '..';

/**
 * @param detectionCapacity - the detection capacity from the user's payment plan
 * @returns The maximum number of audio files a user can upload, or a fallback constant if
 * `detectionCapacity` is null
 */
export const getMaxAudioUploads = (
    detectionCapacity: Maybe<number>,
): number => {
    if (detectionCapacity === null) {
        return constants.MAX_AUDIO_UPLOADS_FALLBACK;
    }

    return detectionCapacity * 2;
};
